/**
 * Gedeelde vertaling tussen de homepage-vragenlijst en de zoekfilters op
 * /zoek-zorgverlener. Keys gaan via de URL (?zorg=…&voor=…&plaats=…).
 */
export const CARE_NEEDS: { key: string; label: string; keywords: string[] }[] = [
  { key: "verzorging", label: "Wassen en aankleden", keywords: ["persoonlijke verzorging", "adl", "verzorgende", "thuiszorg"] },
  { key: "verpleging", label: "Medicatie en verpleging", keywords: ["verpleging", "verpleeg", "medicatie", "palliatie"] },
  { key: "huishouden", label: "Huishouden", keywords: ["huishoud"] },
  { key: "begeleiding", label: "Begeleiding en structuur", keywords: ["begeleid", "dagbesteding", "zelfredzaam", "sociaal"] },
  { key: "dementie", label: "Toezicht bij dementie", keywords: ["dementie", "ouderenzorg"] },
  { key: "nacht", label: "Hulp in de nacht", keywords: ["nacht"] },
  { key: "respijt", label: "Mantelzorger ontlasten", keywords: ["respijt", "logeer", "dagbesteding"] },
];

export const FOR_WHO_OPTIONS: { key: string; label: string; groups: string[] }[] = [
  { key: "kind", label: "Een kind", groups: ["kinderen", "jeugd", "autisme", "adhd"] },
  { key: "volwassene", label: "Een volwassene", groups: ["volwassenen", "nah", "ggz", "lvb"] },
  { key: "oudere", label: "Een oudere", groups: ["ouderen", "ouderenzorg", "dementie"] },
];

const norm = (s: string) => s.toLowerCase().replace(/_/g, " ");

interface Matchable {
  tags?: string[] | null;
  target_groups?: string[] | null;
  city?: string | null;
}

export function matchesNeeds(p: Matchable, needKeys: string[]) {
  if (!needKeys.length) return true;
  const tags = (p.tags || []).map(norm);
  return needKeys.some((k) => {
    const need = CARE_NEEDS.find((n) => n.key === k);
    return !!need && need.keywords.some((kw) => tags.some((t) => t.includes(kw)));
  });
}

export function matchesForWho(p: Matchable, whoKey: string | null) {
  if (!whoKey) return true;
  const opt = FOR_WHO_OPTIONS.find((o) => o.key === whoKey);
  if (!opt) return true;
  const hay = [...(p.target_groups || []), ...(p.tags || [])].map(norm);
  return opt.groups.some((g) => hay.some((h) => h.includes(g)));
}

export function matchesCity(p: Matchable, city: string) {
  if (!city) return true;
  return (p.city || "").toLowerCase().includes(city.toLowerCase());
}
